import React from 'react';
import PropTypes from 'prop-types';

import BaseComponent from '../../common/BaseComponent/BaseComponent';


import Button from '../../common/primitives/Button';
import Price, { FormatPrice } from '../../common/primitives/Price';

import buttons from '../../common/primitives/Button.scss';
import styles from './ComponentCartBig.scss';

import cartImg from './img/cart-small.png';
import ComponentCart from "../ComponentCart/ComponentCart";
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import HelperGoogleAnalytics4 from '../../common/helpers/HelperGoogleAnalytics4';
import { __t } from '../../common/lang/text-resource';

class ComponentCartBig extends BaseComponent {

	data = {};
	isOpen = false;
	loadingInner = true;
	scrollContainer = React.createRef();
	cartContainer = React.createRef();
	isScrollEventSet = false;

	constructor() {
		super(...arguments, 'ComponentCartBig');
	}

	componentDidMount() {
		super.componentDidMount();
		window.addEventListener('resize', () => {
			if (this.cartContainer.current) {
				this.toggleBodyOverflow();
				//ComponentCart.toggleFixedTotalContainer(this.cartContainer.current.totalsContainer.current);
			}

		}, false);
		// if (this.scrollContainer.current) {
		// 	this.scrollContainer.current.addEventListener('scroll', () => {
		// 		if (this.cartContainer.current) {
		// 			ComponentCart.toggleFixedTotalContainer(this.cartContainer.current.totalsContainer.current);
		// 		}
		// 	}, false);
		// }


	}

	toggleBodyOverflow = () => {
		if (this.isOpen) {
			document.getElementsByTagName('body')[0].style.overflow = 'hidden';
		} else {
			document.getElementsByTagName('body')[0].style.overflow = 'auto';
		}
	};
	toggleCart = () => {
		this.isOpen = !this.isOpen;
		if (this.isOpen) {
			const ga4EventItems = this.context.get('ComponentCart').componentData.ga4EventItems;
			const endTotal = this.context.get('ComponentCart').componentData.ga4EndTotal;
			HelperGoogleAnalytics4.TrackViewCart(endTotal, this.data.componentData.currency, ga4EventItems);
		}
		this.toggleBodyOverflow();
		this.forceUpdate();
	};


	render() {

		if (this.loadingInner && this.context.get('ComponentCartBig')) {
			this.loadingInner = false;
		}
		this.data = this.context.get('ComponentCartBig');
		const emptyState =
			<div
				className={`${styles.isEmpty} ${styles.closedState} ${styles.withShadow}`}
				data-layout="text-center">
				<img src={cartImg} alt={__t('Количка')}/>
				{__t('Вашата количка е празна')}
			</div>;

		///////////////////////////////////
		///////////////////////////////////
		///////////////////////////////////
		///////////////////////////////////
		let inactiveState;
		if (this.loadingInner) {
			inactiveState = <div className={styles.mainContainer}>
				<div className={styles.container}>
					<div className={`${styles.isEmpty} ${styles.closedState} ${styles.withShadow}`}
						 data-layout="text-center">
						&nbsp;
					</div>
				</div>
			</div>
		} else {
			if (this.data.componentData.countServices === 0) {
				inactiveState = emptyState;
				if (this.isOpen) {
					this.isOpen = false;
				}
			} else {

				inactiveState =
					<div data-layout="text-center" className={`${styles.closedState} ${styles.withShadow}`}>
						<img src={cartImg} alt={__t("Количка")}/>
						<span>
						<Button
							onClick={this.toggleCart}
							name={'showCart'}
							value={__t('Количка')}
							className={`${buttons.buttonLink} ${buttons.action}`}/>:&nbsp;
							{this.data.componentData.countServices} {this.data.componentData.countServices === 1 ? __t('услуга') : __t('услуги')},&nbsp;
							{__t(':price с ДДС', {price: FormatPrice(Number.parseFloat(this.data.componentData.endTotal), this.data.componentData.currency)})}
					</span>
					</div>;
			}
		}
		///////////////////////////////////
		///////////////////////////////////
		///////////////////////////////////
		///////////////////////////////////
		///////////////////////////////////
		///////////////////////////////////
		///////////////////////////////////
		const componentCart = this.context.get('ComponentCart');
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		return (
			<div className={styles.mainContainer}>
				<div className={styles.container}>
					<div>
						{
							(this.isOpen) ?
								<div>
									<div data-layout="text-center" className={styles.closedState}>
										<img src={cartImg} alt={__t("Количка")}/>
										<Button
											onClick={this.toggleCart}
											name={'hideCart'}
											value={__t('Скриване на детайли')}
											className={`${buttons.buttonLink} ${buttons.action}`}/>
									</div>
								</div>

								:
								inactiveState
						}

						<div className={styles.openCartContainer}>
							<div
								ref={this.scrollContainer}
								className={`${styles.middleContainer} ${this.isOpen ? styles.active : ''} ${this.props.promoBarVisible === true ? styles.promoBarVisible : ''}`}>
								<div className={styles.innerContainer}>
									{
										this.isOpen && this.data.componentData.countServices > 0 &&
										<div>
											<ComponentCart
												data={componentCart}
												showAsPage={true}
												ref={this.cartContainer}/>
											<br/><br/>
										</div>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		);


		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////

	}
}

ComponentCartBig.propsData = {
	showAsPage: PropTypes.bool
};


// React Context binding
ComponentCartBig.contextType = ContextDataStore;

export default ComponentCartBig;